#import "../fragments/sms-broadcast-fragment.graphql"

query GetSmsBroadcast($broadcastId: ID!) {
    smsBroadcast(id: $broadcastId) {
        ...SmsBroadcastFragment
    }
}
